module.exports = __webpack_public_path__ + "media/short-excited-clapping.cab9e1ef.mp3";